module.exports = __webpack_public_path__ + "img/gd.8e690a5a.svg";